import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=802ed54a"
import script from "./Services.vue?vue&type=script&lang=ts"
export * from "./Services.vue?vue&type=script&lang=ts"
import style0 from "./Services.vue?vue&type=style&index=0&id=802ed54a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports